// extracted by mini-css-extract-plugin
export default {"ipad_layout":"index_ipad_layout_LQRPW","layout":"index_layout_aN4--","request_no":"index_request_no_Xsxoo"};